import { URL, handleErrors } from "./depannageActions"
import { getOpenerId } from "../../utilities/session"
import { catchApiError } from "./apiHelpers"

export const POST_FICHE_OUVERTE_BEGIN = "POST_FICHE_OUVERTE_BEGIN"
export const POST_FICHE_OUVERTE_SUCCESS = "POST_FICHE_OUVERTE_SUCCESS"
export const POST_FICHE_OUVERTE_ERROR = "POST_FICHE_OUVERTE_ERROR"
export const POST_FICHE_OUVERTE_RESET = "POST_FICHE_OUVERTE_RESET"
export const SET_FICHE_PRISE = "SET_FICHE_PRISE"
export const CLEAR_FICHE_PRISE = "CLEAR_FICHE_PRISE"
// Demande de prise de main (consentement) : `demande` pour le détenteur (popup
// accepter/refuser), `demandeReponse` pour le demandeur (réponse reçue).
export const SET_FICHE_DEMANDE = "SET_FICHE_DEMANDE"
export const CLEAR_FICHE_DEMANDE = "CLEAR_FICHE_DEMANDE"
export const SET_FICHE_DEMANDE_REPONSE = "SET_FICHE_DEMANDE_REPONSE"
export const CLEAR_FICHE_DEMANDE_REPONSE = "CLEAR_FICHE_DEMANDE_REPONSE"

// Notif « fiche reprise par une autre session » pour CET onglet (le perdant).
export const setFichePrise = (payload) => ({ type: SET_FICHE_PRISE, payload })
export const clearFichePrise = () => ({ type: CLEAR_FICHE_PRISE })

// Demande reçue par le DÉTENTEUR (popup accepter/refuser).
export const setFicheDemande = (payload) => ({
	type: SET_FICHE_DEMANDE,
	payload,
})
export const clearFicheDemande = () => ({ type: CLEAR_FICHE_DEMANDE })

// Réponse reçue par le DEMANDEUR (accepté/refusé).
export const setFicheDemandeReponse = (payload) => ({
	type: SET_FICHE_DEMANDE_REPONSE,
	payload,
})
export const clearFicheDemandeReponse = () => ({
	type: CLEAR_FICHE_DEMANDE_REPONSE,
})

export const postFicheOuverteBegin = () => ({
	type: POST_FICHE_OUVERTE_BEGIN,
})

export const postFicheOuverteSuccess = (payload) => ({
	type: POST_FICHE_OUVERTE_SUCCESS,
	payload,
})

export const postFicheOuverteError = (error) => ({
	type: POST_FICHE_OUVERTE_ERROR,
	payload: error,
})

export const postFicheOuverteReset = () => ({
	type: POST_FICHE_OUVERTE_RESET,
})

// GET de la liste des fiches ouvertes (verrous non périmés). Alimente
// `fichesOuvertes` (même reducer que le POST) pour l'affichage des cadenas et
// l'initialisation de l'état lecture seule.
export function fetchFichesOuvertes() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/ficheouverte`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postFicheOuverteSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, null))
	}
}

export function postFicheOuverte(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		// Heartbeat périodique : ne pas partir avec un `Bearer ` malformé après
		// logout (warning navigateur), la requête serait de toute façon rejetée.
		if (!token) return Promise.resolve()
		dispatch(postFicheOuverteBegin())
		return fetch(`${URL}api/ficheouverte`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ ...data, opener: getOpenerId() }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postFicheOuverteSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, postFicheOuverteError))
	}
}
